import React from 'react'
import { useIntl } from 'react-intl'
import { ICustomerAddress } from 'msp-integrations'
import translations from './AddressDisplay.constants'

type AddressDisplayProps = {
  className?: string
  address: ICustomerAddress
}

export const getSalutation = (address: ICustomerAddress) => {
  const { formatMessage } = useIntl()
  return formatMessage(
    translations[
      address.salutation === 'undefined' || !address.salutation
        ? '_'
        : address.salutation
    ]
  )
}

const AddressDisplay = ({ className = '', address }: AddressDisplayProps) => {
  const { formatMessage } = useIntl()

  return (
    <div className={`font-Roboto text-14 leading-24 tracking-0 ${className}`}>
      {address?.c_isPackstation && (
        <div>
          <span className='italic'>
            {formatMessage({
              defaultMessage: 'To the attention of :',
              id: 'msp.address_form.packstation.attention'
            })}
          </span>
          <span className='font-medium'>
            {` ${getSalutation(address)} ${address.firstName} ${
              address.lastName
            }`}
          </span>
        </div>
      )}
      {!address?.c_isPackstation && (
        <div>
          {` ${getSalutation(address)} ${address.firstName} ${
            address.lastName
          }`}
        </div>
      )}
      <div>{address.address1}</div>
      <div>
        {address.countryCode}-{address.postalCode} {address.city}
      </div>
    </div>
  )
}

export default AddressDisplay
